export default "__VITE_ASSET__Dc3Qq0js__"